import React, { FunctionComponent } from 'react';
import { FooterProps } from '../types/Footer.types';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import './FooterNav.scss';

import { useForceCookieLabel } from '../../../hooks/useForceCookieLabel';

const FooterNavItem = (props: {
  field: FooterProps['fields']['navigation'][number];
}) => {
  const cookieButtonRef = useForceCookieLabel<HTMLButtonElement>(
    props.field.fields.link.value.text,
    props.field.fields.link.value.class === 'cookielaw'
  );

  const linkValue = (prevlink) => {
    let newCLass = props.field.fields.link.value.class='ga4-click-ui-footer'
    return {...prevlink, newCLass}
  }

  return (
    <li>
      {props.field.fields.link.value.class === 'cookielaw' && (
        <>
          {/* OneTrust Cookies Settings button start */}
          <button
            ref={cookieButtonRef}
            id="ot-sdk-btn"
            className="ot-sdk-show-settings "
          ></button>
          {/* OneTrust Cookies Settings button end */}
        </>
      )}
      {props.field.fields.link.value.class !== 'cookielaw' && (
        <Link field={linkValue(props.field.fields.link)} />
      )}
    </li>
  );
};

const FooterNav: FunctionComponent<{
  usefulLinks: FooterProps['fields']['navigation'];
}> = ({ usefulLinks }) => {
  return (
    <div className="FooterNav">
      <nav>
        <ul>
          {usefulLinks.length > 0 &&
            usefulLinks.map((link, idx) => (
              <FooterNavItem key={idx} field={link} />
            ))}
        </ul>
      </nav>
    </div>
  );
};

export default FooterNav;
